import React, { Component } from 'react';
import SVGInline from 'react-svg-inline';

export default class Clave extends Component {
	render() {
		// const principal = this.props.agrupaciones[this.props.ide];
		// const secundaria = (this.props.ideSec) ? this.props.agrupaciones[this.props.ideSec] : "";

		return (
			<div className="clave">
				<ul>
					{this.props.agrupaciones[this.props.ide] ? (
						<li>
							<span className="svgSpan" style={{ marginRight: '1rem' }}>
								<SVGInline
									svg={`<svg width='16' height='16' viewBox='0 -2 16 14.6'><path fill=${
										this.props.mainColor
									} d='M11.8.3H4.2L.4 6.9l3.8 6.7h7.6l3.9-6.7'/></svg>`}
								/>
							</span>
							{this.props.agrupaciones[this.props.ide].nom}
						</li>
					) : (
						''
					)}

					{this.props.agrupaciones[this.props.ideSec] ? (
						<li>
							<span className="svgSpan" style={{ marginRight: '1rem' }}>
								<SVGInline
									svg={`<svg width='16' height='16' viewBox='0 -2 16 14.6'> <path d='M10.31 2l2.67 4.62-2.67 4.62H4.97L2.3 6.62 4.97 2h5.34m1.15-2H3.82L0 6.62l3.82 6.62h7.65l3.82-6.62L11.47 0z'/></svg>`}
								/>
							</span>
							{this.props.agrupaciones[this.props.ideSec].nom}
						</li>
					) : (
						''
					)}
				</ul>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Clave.js